import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Content, PageHeader, Label, Spinner, AlertBar,ButtonWithLoading } from 'scorer-ui-kit';
import { PageHeaderContainer, DeviceNameLabel, SpinnerDesign, AlertContainer, RightAlignedContainer, NoteLabel } from '../Style';
import { useDevice } from '../hooks/useDevice';
import { CenterAlignedContainer } from '../Style';
import { BoxContainer } from '../components/BoxContainer';
import { BASE_URL } from '../constants';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

const DownloadLabel = styled(Label)`
  font-size: 15px;
`;

const DebugBoxContainer = styled(BoxContainer)`
  width: max-content;
`;

function DebugLogs() {
  const { state: { device, status_code, deviceLoading, message }, actions: { fetchDevice } } = useDevice();
  const [alert, setAlert] = useState<{ key?: any, message: string, type: 'success' | 'error' | 'warning' | 'info' | undefined }>({ key: new Date(), message: '', type: undefined });
  const [loading, setLoading] = useState<boolean>(false);

  const { t } = useTranslation(['DebugLogs', 'Common']);
  const location = useLocation();

  useEffect(() => {
    if (!deviceLoading) {
       if (status_code === '2') {
        setAlert({ key: new Date(), message: t('Common:deviceNotFound'), type: 'info' });
      } 
    }
  }, [device,status_code, deviceLoading, message, t]);

  const onDownload = () => {
    setLoading(true);
    try {
      const url =BASE_URL + '/debug-log/export/' +Date.now()
      if (url) {
        if (url !== null && url !== undefined) {
          var link = document.createElement('a');
          link.href = url;
          link.download = url.substr(url.lastIndexOf('/') + 1);
          link.click();
        }
      }
    } catch (error) {
      console.error(error.message);

    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDevice();
  }, [fetchDevice]);

  useEffect(() => {
    sessionStorage.removeItem('cameraTab');
    sessionStorage.removeItem('notificatioinTab');
    sessionStorage.removeItem('auditLogTab');
  }, [location]);
 
  return (
    <Content>
      <PageHeaderContainer>
        <PageHeader title={t('debugLogs')} icon='Detection' areaTitle={t('Common:home')} areaHref='/' />
        <DeviceNameLabel htmlFor='' labelText={device.name} />
        <NoteLabel htmlFor='' labelText={device.detail} />
      </PageHeaderContainer>
      {
        deviceLoading ?
          <CenterAlignedContainer>
            <Spinner size='large' styling={SpinnerDesign} />
          </CenterAlignedContainer> :
          (alert.message === '' ?
          <DebugBoxContainer title=''>
            <DownloadLabel htmlFor='' labelText={t('downloadMessage')} />
            <RightAlignedContainer>
              <ButtonWithLoading loading={loading} design='primary' onClick={onDownload}>{t('download')}</ButtonWithLoading>
            </RightAlignedContainer>
          </DebugBoxContainer>
            :
            <AlertContainer key={alert.key}>
              <AlertBar type={alert.type} message={alert.message} />
            </AlertContainer>)
      }
    </Content>
  )
}

export default DebugLogs;
